// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import _ from 'underscore';

import {Collection as BioJSAnnotations} from 'biojs/Annotation';
import * as MapsConstants from 'constants/MapsConstants';
import Annotation from 'molbio/annotations/backbone/Annotation';
import * as mapsutil from 'molbio/maps/MapsUtil';
import * as selectables from 'molbio/maps/selectables/Selectables';
import * as sequtil from 'molbio/SeqUtil';

class Annotations extends selectables.Collection<Annotation> {
  _annotations!: BioJSAnnotations;

  static initClass(): void {
    this.prototype.model = Annotation;
  }
  batchName(): string {
    return 'annotations';
  } // should match biojs/annotation.js
  override initialize(models: Array<Annotation>, options: selectables.SelectableOptions<Annotation>): void {
    // @ts-expect-error
    // oxlint-disable-next-line prefer-rest-params
    super.initialize(...arguments);
    this.setLayers();

    // There are places in the code where we iterate through all the annotations and make changes.
    // These methods only need to be triggered once (and its results get used by views), so we batch
    // process the computations.

    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.setLayers = this.batch(this.setLayers);
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.computeVisibilities = this.batch(this.computeVisibilities);

    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.on('add remove change:_annotation change:visible reset', this.setLayers);
    // eslint-disable-next-line @typescript-eslint/unbound-method
    return this.on('add remove change:_annotation change:visible reset', this.computeVisibilities);
  }

  computeVisibilities(): void {
    const validType = (type: string | null): boolean => type != null && type !== '';
    const types: Array<string> = this.chain()
      .map((item: Annotation) => item.annotationType())
      .filter((type: string) => validType(type))
      .uniq()
      .value();
    const visibilities: {[annotationType: string]: [boolean, boolean]} = {};
    // oxlint-disable-next-line no-var, vars-on-top
    for (var type of Array.from(types)) {
      visibilities[type] = [true, false];
    }

    let global = [true, false];
    this.each((annotation: Annotation): void => {
      const visible = annotation.visible();
      global = [global[0] && visible, global[1] || visible];
      // oxlint-disable-next-line block-scoped-var
      type = annotation.annotationType();
      // oxlint-disable-next-line block-scoped-var
      if (validType(type)) {
        // @ts-expect-error: should remove return statement here
        // oxlint-disable-next-line block-scoped-var, no-return-assign
        return (visibilities[type] = [visibilities[type][0] && visible, visibilities[type][1] || visible]);
      }
    });

    let allTypes = [true, false];
    // oxlint-disable-next-line block-scoped-var
    for (type of Array.from(types)) {
      // oxlint-disable-next-line block-scoped-var
      allTypes = [visibilities[type][0] && allTypes[0], visibilities[type][1] || allTypes[1]];
    }
    return this.trigger('visibilities', visibilities, allTypes, global);
  }

  override slice(
    start: number,
    end: number,
    filter: null | ((annotations: Array<Annotation>) => Array<Annotation>) = null
  ): Array<Annotation> {
    let data = this.filter((annotation) => {
      const aStart = annotation.get('_annotation').start();
      const aEnd = annotation.get('_annotation').end();
      return annotation.get('visible') && sequtil.isRangeOverlap(start, end, aStart, aEnd);
    });

    if (filter != null) {
      data = filter(data);
    }

    return _.sortBy(data, (annotation) => {
      const x1 = Math.max(start, annotation.get('_annotation').start()) - start;
      const x2 = Math.min(end, annotation.get('_annotation').end()) - start;
      return x1 - x2;
    });
  }

  setFullLayers(): void {
    const modelsAndLayers = mapsutil.getModelLayers(
      this.filter((ann) => ann.get('visible')),
      {top: false}
    );
    for (const {model, layer} of Array.from(modelsAndLayers)) {
      model.set(MapsConstants.LINEAR_LAYER_FULL, layer, {silent: true});
    }
  }

  setLayers(): void {
    this.setFullLayers();
    this.trigger('layerChange');
  }
}
Annotations.initClass();

export default Annotations;
